import React from 'react';
import ScoreSummaryCard from '@Local/Measurement/Components/ScoreSummaryCard/ScoreSummaryCard';
import WeightManagementCard from '@Local/Measurement/Components/WeightManagementCard/WeightManagementCard';
import MetricRangeCard from '@Local/Measurement/Components/MetricRangeCard/MetricRangeCard';
import { Grid } from '@curves/ui-base';

/**
 * UI組件展示頁面
 * 用於開發時確認各種UI組件的顯示效果
 */
const ComponentTestPage = () => {
    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <ScoreSummaryCard className={'mb-4'} bodyTypeLabel={'強健型'} totalInBodyScore={88} />
                </Grid>
            </Grid>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <WeightManagementCard
                        className={'mb-4'}
                        currentWeightKg={65.2}
                        targetWeightKg={63.0}
                        weightControl={{
                            theme: 'negative',
                            valueKg: -2.2,
                        }}
                        fatControl={{
                            theme: 'negative',
                            valueKg: -1.5,
                        }}
                        muscleControl={{
                            theme: 'positive',
                            valueKg: 0.7,
                        }}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <MetricRangeCard
                        title="骨骼肌質量 (SMM)"
                        previousValue={24.3}
                        currentValue={24.5}
                        standardRangeMin={21.5}
                        standardRangeMax={26.3}
                        unitLabel={'kg'}
                    />
                </Grid>
            </Grid>
        </>
    );
};

export default ComponentTestPage;
